import { render, staticRenderFns } from "./BaysDetails.vue?vue&type=template&id=5d42d4b8&scoped=true&lang=pug&"
import script from "./BaysDetails.vue?vue&type=script&lang=js&"
export * from "./BaysDetails.vue?vue&type=script&lang=js&"
import style0 from "./BaysDetails.vue?vue&type=style&index=0&id=5d42d4b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d42d4b8",
  null
  
)

export default component.exports